<template>
    <section>
        <section v-if="!details.is_started" class="text-center">
            <h1 class="mb-0 mt-5 mb-3">{{$t('quizzes.good_luck')}} {{subject.course_name}}</h1>
            <svg v-svg="'icon-start'" size="12" style="width: 58px; height: 58px" class="mt-10" @click="$refs.preparing.dialog = true"></svg>
        </section>

        <section v-else-if="details.is_finished">
            <p class="font-weight-bold text-center mt-10">{{$t('quizzes.check_result')}}</p>
        </section>

        <section v-else class="px-16 sectionMain">
            <h1 class="mt-5 mb-3 text-center">{{$t('quizzes.questions')}} ({{ quiz.currentIndex }}/{{ quiz.total}})</h1>
            <timer ref="timer"
                   :minutes="quiz.current.time"
                   :key='details.indexTime'
                   @timeout="[next({timeout: true}),
                   $store.dispatch('alert', {type: 4, message: $t('quizzes.warning_skipped') + ' ' + $t('quizzes.timeout')})]"
            ></timer>
            <section class="d-flex flex-column align-center">
                <pre class="ma-5" @click.right.prevent @copy.prevent @paste.prevent>{{ quiz.current.title }}</pre>

                <v-img class="mt-2 mb-5" :src="`${API_URL}/storage/quizzes/${quiz.current.image}`" width="40%" v-if="quiz.current.image"/>

                <v-card-text class="pa-0 d-flex justify-center">
                    <one-answer v-if="quiz.current.type === 1"
                                ref='oneAnswer'
                                @change='quiz.answers = $event'
                                :items="quiz.current.answers">
                    </one-answer>

                    <multiple-answer v-else-if="quiz.current.type === 2"
                                     ref='multipleAnswer'
                                     @change='quiz.answers = $event'
                                     :items="quiz.current.answers">
                    </multiple-answer>

                    <v-textarea v-else :label="$t('quizzes.answer')" v-model="quiz.answers" color="green" class="ma-5"></v-textarea>
                </v-card-text>

                <v-card-actions>
                    <v-btn class="orange-btn white--text mr-4" @click="next({ skipped : true })">{{$t('quizzes.skip')}}</v-btn>
                    <v-btn class="green white--text ml-4" @click="next">{{quiz.currentIndex === quiz.total ? $t('quizzes.finish') : $t('quizzes.next')}}</v-btn>
                </v-card-actions>

                <p class="score mt-3">({{$t('quizzes.score')}}: {{ quiz.current.score }})</p>
            </section>
        </section>

        <preparing @fetched="startQuiz" ref="preparing" :quiz_id="details.quiz_id"></preparing>
    </section>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Preparing from '@/components/Quizzes/Preparing';
    import OneAnswer from '@/components/Quizzes/OneAnswer';
    import MultipleAnswer from '@/components/Quizzes/MultipleAnswer';
    import Timer from '@/components/Quizzes/Timer';
    export default {
        components: {
            Preparing,
            Timer,
            OneAnswer,
            MultipleAnswer,
        },

        data(){
            return {
                details: {
                    quiz_id: this.$route.query.quiz_id,
                    is_started: false,
                    is_finished: false,
                    loaded: false,
                    indexTime: 0,
                },

                quiz: {
                    total: null,
                    questions: [],
                    salt: null,
                    currentIndex: 0,
                    current: {},
                    answers: [],
                }
            }
        },

        computed: {
            ...mapGetters(['QUIZZES']),
            subject(){
                return this.QUIZZES.find(item => item.id == this.details.quiz_id) || {};
            }
        },

        mounted(){
            if(localStorage.getItem("reload")){
                this.$api('quizzes').getQuiz(this.details.quiz_id).then((res) => {
                    this.$store.commit("SET_QUIZZES", res.data.quizzes)
                    this.startQuiz( JSON.parse(res.data.quiz), res.data.salt)
                    let count = JSON.parse(res.data.answers).length
                    this.quiz.currentIndex = count+1;
                    while (count--)
                        this.quiz.current = this.quiz.questions.next().value;

                }).catch(() => {
                    this.$store.dispatch('alert', {type: 2, message: this.$t('quizzes.error_fetch')});
                })
            }else {
                localStorage.setItem('reload','refreshPage')
            }
            this.initUserChecker();
        },

        beforeDestroy(){
            if(this.details.is_started && !this.details.is_finished) {
                this.next({finishQuiz: true});
                this.$store.dispatch('alert', {type: 4, message: this.$t('quizzes.warning_ended')});
            }
            window.removeEventListener('blur', this.blurEvent);
        },

        methods: {
            startQuiz(quizzes, salt) {
                if(!quizzes.length) {
                    this.$store.dispatch('alert', {type: 2, message: this.$t('quizzes.error_questions')});
                    return;
                }

                this.details.is_started = true;
                this.quiz.total = quizzes.length;
                this.quiz.questions = this.quizGenerator(quizzes);
                this.quiz.salt = salt;
                this.next();
            },

            quizGenerator: function* (quizzes) {
                yield* quizzes;
            },

            next(params = {}) {
                const {skipped, cheated, timeout, finishQuiz} = params;

                const isFinished = this.quiz.currentIndex === this.quiz.total || finishQuiz;
                let answers = Array.isArray(this.quiz.answers) ? this.quiz.answers : [this.quiz.answers];

                if((((!skipped && !cheated && !timeout) && !answers.length && this.details.loaded)) && !finishQuiz) {
                    this.$store.dispatch('alert', {type: 2, message: this.$t('quizzes.error_select_answer')});
                    return;
                }

                if(skipped || cheated || timeout) answers = [];

                const quizInfo = {
                    course_id: this.subject.course_id,
                    answers: answers,
                    skipped: skipped || false,
                    timeout: timeout || false,
                    cheated: cheated || false,
                    question_id: this.quiz.current.id,
                    salt: this.quiz.salt,
                    time: this.$refs.timer ? (this.$refs.timer.time_spent || 0) : 0
                };

                if(isFinished) {
                    localStorage.removeItem('reload')
                    this.$refs.timer.stopTimer();
                    this.details.is_finished = true;

                    this.$api('quizzes').changeQuizStatus({salt:this.quiz.salt, status: 3})
                } else {
                    this.quiz.current = this.quiz.questions.next().value;
                    this.quiz.currentIndex++;
                }
                this.details.indexTime++;
                this.quiz.answers = [];
                if(this.$refs.oneAnswer) this.$refs.oneAnswer.selected = [];
                if(this.$refs.multipleAnswer) this.$refs.multipleAnswer.selected = [];
                if(finishQuiz) quizInfo.answers = [];

                quizInfo.answers = quizInfo.answers.map((answer) => {
                    return btoa(unescape(encodeURIComponent(answer)))
                })

                if(this.details.loaded) {
                    this.$api('quizzes').answer(quizInfo).then(() => {
                    }).catch(() => {
                        this.$store.dispatch('alert', {type: 2, message: this.$t('quizzes.error_wrong')});
                    });
                }

                if(!this.details.loaded) this.details.loaded = true;
            },

            initUserChecker() {
                window.addEventListener('blur', this.blurEvent)
                window.addEventListener('onbeforeunload', this.refreshPage);
            },

            blurEvent() {
                if(this.details.is_started && !this.details.is_finished) {
                    this.next({cheated: true});
                    this.$store.dispatch('alert', {type: 4, message: this.$t('quizzes.warning_skipped') + ' ' + this.$t('quizzes.cheat')});
                }
            },

            refreshPage() {
                if(confirm('If you leave the page your quiz will be failed.')) {
                    if(this.details.is_started && !this.details.is_finished) {
                        this.next({finishQuiz: true});
                        this.$store.dispatch('alert', {type: 4, message: this.$t('quizzes.warning_ended')});
                    }
                    window.removeEventListener('onbeforeunload', this.refreshPage);
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/pages/Quizzes/start";
</style>